var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "govgr-layout-wrapper govgr-layout-wrapper__full-height",
      attrs: { id: "app" }
    },
    [
      _c("div", { staticClass: "govgr-header" }, [_c("Navbar")], 1),
      _vm._v(" "),
      _c("div", { staticClass: "gov-width-container" }, [_c("router-view")], 1),
      _vm._v(" "),
      _c("div", { staticClass: "govgr-footer" }, [_c("Foot")], 1)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-04c2046b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04c2046b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 